import { render, staticRenderFns } from "./default.vue?vue&type=template&id=473c1c1a&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainHeader: require('/vercel/path0/components/navigation/MainHeader.vue').default,PageFooter: require('/vercel/path0/components/PageFooter.vue').default})
